$(function() {
  if($("#kxmegane").is(':visible')) {
    // URLパラメーターからdebug_modeを取得
    const debugMode = window.location.search.includes('debug_mode=true');
    let currentConcept = null;
    // 質問の番号
    let idx = 0;
    let questions = [];
    let answers = [];
    let favoriteQuestions = [];

    /*
     ＊ アニメーション速度
     ＊ urlパラメーターでデバッグ用の値を設定できる
     ＊ /kxmegane/new?bg_animation_speed=500&question_blink_speed=100&question_animation_speed=10
     */
     // エリア移動アニメーションの速さ
    const BG_ANIMATION_SPEED = parseInt(window.location.search.split('bg_animation_speed=')[1]) || 3000;
    // 質問切り替え時の点滅速度
    const QUESTION_BLINK_SPEED = parseInt(window.location.search.split('question_blink_speed=')[1]) || 200;
    // 質問切り替え速度
    const QUESTION_ANIMATION_SPEED = parseInt(window.location.search.split('question_animation_speed=')[1]) || 200;

    // CSSアニメーション速度設定
    $(".kxmegane-label").css("animation-duration", `${QUESTION_BLINK_SPEED / 1000}s`);
    $("#kxmegane_question-wrap").css("animation-duration", `${QUESTION_ANIMATION_SPEED / 1000}s`);

    /*
     * エリア移動を背景のアニメーションギミック 
     * 
     * 表示するポジションの座標
     * centerX: 元サイズの背景画像の表示したい横座標の中央位置 px
     * centerY: 元サイズの背景画像の表示したい横座標の中央位置 px
     * displayHeight: 座標中央から上下範囲で表示したい領域 px
     */

    // 背景画像の元サイズ（px）
    const BG_IMAGE_WIDTH = 4000;
    const BG_IMAGE_HEIGHT = 4223;

    // 中央に寄った際の倍率
    const CENTER_ZOOM_SCALE = 2.2;

    // 各ページのzoomを微調整
    const PAGE_SCALE = 0.8;

    // デバイス判定関数
    function isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
             window.innerWidth <= 768;
    }

    // 画面サイズ変更の検知を改善
    let resizeTimeout;
    let lastWindowHeight = window.innerHeight;
    let lastWindowWidth = window.innerWidth;
    let isUrlBarHidden = false;

    // URLバーの表示/非表示を検知する関数
    function detectUrlBarChange() {
      const currentHeight = window.innerHeight;
      const currentWidth = window.innerWidth;
      
      // 高さの変化がURLバーの表示/非表示によるものかチェック
      const heightDiff = Math.abs(currentHeight - lastWindowHeight);
      const widthDiff = Math.abs(currentWidth - lastWindowWidth);
      
      // リサイズ時は背景の調整のみ行い、蝶の位置変更は行わない
      if (heightDiff > 0 || widthDiff > 0) {
        setKxmeganeBg(currentCenterX, currentCenterY, currentDisplayHeight, currentDisplayWidth, currentWidth);
      }
      
      lastWindowHeight = currentHeight;
      lastWindowWidth = currentWidth;
    }

    // デバウンス処理付きのリサイズハンドラー
    function debouncedResizeHandler() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(detectUrlBarChange, 150);
    }

    // ビューポートの変化を検知（より確実な方法）
    function handleViewportChange() {
      const currentHeight = window.innerHeight;
      const currentWidth = window.innerWidth;
      
      // 画面の向きが変わった場合の処理
      if (Math.abs(currentHeight - lastWindowHeight) > 50 || Math.abs(currentWidth - lastWindowWidth) > 50) {
        // 画面の向きが変わった場合は背景の調整のみ
        setTimeout(() => {
          setKxmeganeBg(currentCenterX, currentCenterY, currentDisplayHeight, currentDisplayWidth);
        }, 300);
      }
      
      lastWindowHeight = currentHeight;
      lastWindowWidth = currentWidth;
    }

    // 画面の向き変更を検知
    $(window).on('orientationchange', function() {
      setTimeout(handleViewportChange, 500);
    });

    // 蝶の着地位置（画面の%で指定）
    const BUTTERFLY_LANDING_POSITIONS = [
      { areaId: "bgarea1", percentX: 0, percentY: 0, enabled: false, multipleButterflies: false }, // 初期画面
      { areaId: "bgarea2", percentX: 0, percentY: 0, enabled: false, multipleButterflies: false }, // ガイダンス
      { 
        areaId: "bgarea3", 
        percentX: isMobileDevice() ? -8 : 21, 
        percentY: isMobileDevice() ? 65 : 56, 
        enabled: true, 
        multipleButterflies: false 
      }, // wagamama
      { 
        areaId: "bgarea4", 
        percentX: isMobileDevice() ? 80 : 75, 
        percentY: isMobileDevice() ? 55 : 60, 
        enabled: true, 
        multipleButterflies: true 
      }, // tabinonakama
      { 
        areaId: "bgarea5", 
        percentX: isMobileDevice() ? -5 : 24, 
        percentY: isMobileDevice() ? 62 : 62, 
        enabled: true, 
        multipleButterflies: false 
      }, // tsunagari
      { areaId: "bgarea6", percentX: 0, percentY: 0, enabled: false, multipleButterflies: false }, // 休憩画面
      { 
        areaId: "bgarea7", 
        percentX: isMobileDevice() ? 4 : 27, 
        percentY: isMobileDevice() ? 76 : 62, 
        enabled: true, 
        multipleButterflies: false 
      }, // omoi
      { 
        areaId: "bgarea8", 
        percentX: isMobileDevice() ? 76 : 90, 
        percentY: isMobileDevice() ? 30 : 33, 
        enabled: true, 
        multipleButterflies: false 
      }, // kikai
      { areaId: "bgarea9", percentX: 0, percentY: 0, enabled: false, multipleButterflies: false }, // 結果画面
    ];

    // 背景画像のポジション・サイズ
    const BG_BACKGROUND_POSITION_LIST = [
      { areaId: "bgarea1", centerX: 2020, centerY: 806,  displayHeight: 1105 * PAGE_SCALE ,displayWidth: 1305 * PAGE_SCALE},
      { areaId: "bgarea2", centerX: 2928, centerY: 1393, displayHeight: 557 * PAGE_SCALE  ,displayWidth: 757 * PAGE_SCALE },
      { areaId: "bgarea3", centerX: 3183, centerY: 2150, displayHeight: 612 * PAGE_SCALE  ,displayWidth: 612 * PAGE_SCALE },// wagamama
      { areaId: "bgarea4", centerX: 3100, centerY: 2856, displayHeight: 600 * PAGE_SCALE  ,displayWidth: 700 * PAGE_SCALE },// tabinonakama
      { areaId: "bgarea5", centerX: 2183, centerY: 3217, displayHeight: 350 * PAGE_SCALE  ,displayWidth: 430 * PAGE_SCALE },// tsunagari
      { areaId: "bgarea6", centerX: 1381, centerY: 3350, displayHeight: 300 * PAGE_SCALE  ,displayWidth: 450 * PAGE_SCALE },// 休憩
      { areaId: "bgarea7", centerX: 1221, centerY: 2886, displayHeight: 458 * PAGE_SCALE  ,displayWidth: 508 * PAGE_SCALE },// omoi
      { areaId: "bgarea8", centerX: 870,  centerY: 2395, displayHeight: 607 * PAGE_SCALE  ,displayWidth: 607 * PAGE_SCALE },// kikai
      { areaId: "bgarea9", centerX: 956,  centerY: 1660, displayHeight: 682 * PAGE_SCALE  ,displayWidth: 682 * PAGE_SCALE },
    ];

    // デフォルトのポジション・サイズ
    let currentCenterX = BG_BACKGROUND_POSITION_LIST[0].centerX;
    let currentCenterY = BG_BACKGROUND_POSITION_LIST[0].centerY;
    let currentDisplayHeight = BG_BACKGROUND_POSITION_LIST[0].displayHeight;
    let currentDisplayWidth = BG_BACKGROUND_POSITION_LIST[0].displayWidth;

    /*---------------------------------
     * 初期表示
     ---------------------------------*/

    // 画像読み込み進捗管理
    function loadImagesWithProgress(imageUrls, onComplete) {
      let loadedCount = 0;
      const totalImages = imageUrls.length;
      
      function updateProgress() {
        const progress = Math.round((loadedCount / totalImages) * 100);
      }
      
      imageUrls.forEach((url, index) => {
        const xhr = new XMLHttpRequest();
        
        // 進捗イベント
        xhr.onprogress = function(e) {
          if (e.lengthComputable) {
            const imageProgress = Math.round((e.loaded / e.total) * 100);
            // 個別画像の進捗も表示
            $('.kxmegane-loading-per').text(`${imageProgress}%`);
          }
        };
        
        // 読み込み完了
        xhr.onload = function() {
          loadedCount++;
          updateProgress();
          
          if (loadedCount === totalImages) {
            onComplete();
          }
        };
        
        // 読み込みエラー
        xhr.onerror = function() {
          loadedCount++;
          updateProgress();
          
          if (loadedCount === totalImages) {
            onComplete();
          }
        };
        
        // 読み込み開始
        // xhr.onloadstart = function() {
        //   console.log(`画像読み込み開始: ${url}`);
        // };
        
        // リクエスト開始
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.send();
      });
    }

    // 読み込む画像のリスト
    const imagesToLoad = [
      '/kxmegane/img/kx_megane_background.png'
    ];

    // 画像読み込み開始
    loadImagesWithProgress(imagesToLoad, function() {
      // 全ての画像読み込みが完了したら初期表示を開始
      initializeDisplay();
    });

    function initializeDisplay() {
      // ローディング表示を非表示に
      $('#kxmegane-loading').fadeOut(200, function() {
        $(this).remove();
      });

      // まずズームアウト状態で表示
      zoomOutAndCenterBg();

      // 一定時間後に一つ目のエリアにズームイン デフォルト背景表示してからアニメーション設定
      setTimeout(function() {
        // トランジションを有効化
        $('.kxmegane-background-inner')
        .css({
          'transition': `background-size ${BG_ANIMATION_SPEED/1000}s cubic-bezier(0.4,0,0.2,1), background-position ${BG_ANIMATION_SPEED/1000}s cubic-bezier(0.4,0,0.2,1)`
        });
        
        // トランジションが確実に適用されるまで待ってから背景位置を設定
        setTimeout(function() {
          setKxmeganeBg(currentCenterX, currentCenterY, currentDisplayHeight, currentDisplayWidth);
        }, 100);
      }, 100);

      // デフォルトのコンテンツを表示
      setTimeout(function() {
        $('.kxmegane-content').css({
          'opacity': 1,
        });
      }, BG_ANIMATION_SPEED + 200 ); // 200ms → BG_ANIMATION_SPEED + 200msに戻す
    }

    /*---------------------------------
     * 個別の画面遷移
     ---------------------------------*/

    // TOPのボタン処理
    $("#kxmegane_1to2").on("click", function(){
      switchContentAndTransitionBg("#kxmegane_page1_top", "#kxmegane_page2_guidance", "bgarea2");
    })

    // ガイダンスのボタン処理
    $("#kxmegane_2to3").on("click", function(){
      init();
      showQuestion();
      switchContentAndTransitionBg("#kxmegane_page2_guidance", "#kxmegane_page3_qestions", "bgarea3");
    })

    // ガイダンスからトップに戻る
    $("#kxmegane_2to1").on("click", function(){
      switchContentAndTransitionBg("#kxmegane_page2_guidance", "#kxmegane_page1_top", "bgarea1");
    });

    // 休憩から次の質問に進む
    $("#kxmegane_4to5").on("click", function(){
      switchContentAndTransitionBg("#kxmegane_page4_rest", "#kxmegane_page3_qestions", "bgarea7");
    });
    
    // 休憩から前の質問に戻る
    $("#kxmegane_4to3").on("click", function(){
      switchContentAndTransitionBg("#kxmegane_page4_rest", "#kxmegane_page3_qestions", "bgarea5");
    });

    // 回答完了画面から質問に戻る
    $("#kxmegane_5to3").on("click", function(){
      idx = 49;
      switchContentAndTransitionBg("#kxmegane_page5_guidance", "#kxmegane_page3_qestions", "bgarea8");
    });

    // 自分にとって大切な質問へ遷移
    $("#kxmegane_5to6").on("click", function(){
      showFavoriteQuestion();
      switchContentAndTransitionBg("#kxmegane_page5_guidance", "#kxmegane_page6_favorite_questions");
    });

    // お気に入りの質問選択画面から　お気に入りの質問説明画面に戻る
    $("#kxmegane_6to5").on("click", function(){
      switchContentAndTransitionBg("#kxmegane_page6_favorite_questions", "#kxmegane_page5_guidance");
      prevQuestion();
    });
    
    // 名前入力から自分にとって大切な質問へ戻る
    $("#kxmegane_7to6").on("click", function(){
      switchContentAndTransitionBg("#kxmegane_page7_name", "#kxmegane_page6_favorite_questions");
    });

    // 最終画面から名前入力へ戻る
    $("#kxmegane_8to7").on("click", function(){
      switchContentAndTransitionBg("#kxmegane_page8_last", "#kxmegane_page7_name", "bgarea1");
    });

    // ｢自分にとって大切｣なものから会社名の入力画面へ遷移
    $("#kxmegane_btn_to_company").on("click", function(){
      element = $('input[data-question-number]:checked')

      if (element.length == 0) {
        $("#kxmegane_question-error2").html("｢自分にとって大切｣なものを1つ以上選択してください。");
        return;
      };

      // デバッグモードの場合、選択された質問IDをログ出力
      if (debugMode) {
        console.log("Selected favorite questions:");
        element.each(function() {
          console.log("Question ID:", $(this).data("question-number"));
        });
      }

      // この画面には「戻る」で何度でも入り直せるため、毎回選択内容から作り直す。
      // pushだけだと再訪のたびに重複蓄積し、6件以上になってサーバー側の
      // バリデーション(1〜5件)で弾かれ「診断結果を保存出来ませんでした」になる。
      favoriteQuestions = [];

      element.map(function(){
        favoriteQuestions.push($(this).data("question-number"));
      });

      // デバッグモードの場合、デバッグエリアを更新
      if (debugMode) {
        updateDebugArea();
      }

      switchContentAndTransitionBg("#kxmegane_page6_favorite_questions", "#kxmegane_page7_name");
    });

    // 最終画面への遷移 フォームを生成
    $("#kxmegane_btn_to_last").on("click", function(){
      let form_error = []

      // 名前と会社名のフォームを生成
      if($('#input_company_name').val().trim() === ""){
          form_error.push("会社名を入力してください");
      }

      if($('#input_name').val().trim() === ""){
          form_error.push("名前を入力してください");
      }

      if(form_error.length > 0){
        $("#kxmegane_question-error3").html(form_error.join("<br>"));
        return
      }
  
      // 既存のhidden inputをクリア（重複を防ぐため）
      $('.kxmegane_submit input[name="kxmegane[answers][]"]').remove();
      $('.kxmegane_submit input[name="kxmegane[favorite_questions][]"]').remove();
      $('.kxmegane_submit input[name="kxmegane[name]"]').remove();
      $('.kxmegane_submit input[name="kxmegane[company_name]"]').remove();
  
      // answers配列を元の質問順序で再構築
      answers = [];
      for (let i = 0; i < questions.length; i++) {
        answers.push(questions[i][1]);
      }

      $.each(answers, function(index, answer) {
        html = `<input type="hidden" name="kxmegane[answers][]" value="${answer}">`
        $('.kxmegane_submit').append(html);
      });

      $.each(favoriteQuestions, function(index, favoriteQuestion) {
        html = `<input type="hidden" name="kxmegane[favorite_questions][]" value="${favoriteQuestion}">`
        $('.kxmegane_submit').append(html);
      });

      $('.kxmegane_submit').append(`<input type="hidden" name="kxmegane[name]" value="${$('#input_name').val()}">`);
      $('.kxmegane_submit').append(`<input type="hidden" name="kxmegane[company_name]" value="${$('#input_company_name').val()}">`);

      // エラーメッセージをクリア
      clearValidationErrors();
      
      // フォーム生成後にイベントハンドラーを設定
      setupFormValidation();
      
      switchContentAndTransitionBg("#kxmegane_page7_name", "#kxmegane_page8_last", "bgarea1");
    });

    /**
     * 初期化処理
     */
    function init() {
      // 初期化処理
      questions = [];
      
      // querstionDataはオブジェクトなので、キーでソートして配列として処理
      const questionKeys = Object.keys(querstionData).sort((a, b) => parseInt(a) - parseInt(b));
      
      questionKeys.forEach(function(key) {
        const value = querstionData[key];
        questions.push([value.TEXT, 0, false, value.CONCEPT]);
      });

      favoriteQuestions = [];
      companyName = '';
      idx = 0;

      // エラー文削除
      $("#question-error").html("");
      $("#question-error2").html("");

      // ボタンを表示
      $("#btnFin").hide();
      $("#btnNext").show();

      // チェックボックスのリセット
      $("input[name=answer]:checked").prop("checked",false);

      // デバッグモードの場合、デバッグエリアをクリア
      if (debugMode) {
        $('.debug-area').addClass('hidden').html('');
      }
    }

    /**
     * 問題表示
     */

    function showQuestion() {
      // 質問の設置
      $("#kxmegane_question-q").html(questions[idx][0]);

      // 質問のセクションごとでマージンを変え背景を避けるためにcss用のクラスを付与
      // questions[idx][3]) 4 wagamama
      // questions[idx][3]) 2 tabinonakama
      // questions[idx][3]) 3 tsunagari
      // questions[idx][3]) 1 omoi
      // questions[idx][3]) 5 kikai
      if(currentConcept !== questions[idx][3]) {
        $("#kxmegane_question-wrap").removeClass("m--1 m--2 m--3 m--4 m--5");
        $("#kxmegane_question-wrap").addClass(`m--${questions[idx][3]}`);
      }

      // 画像の表示
      // if(currentConcept !== questions[idx][3]){
      //   $("#kxmegane_question-title").html('<img src="/kxmegane/img/concept_title_' + questions[idx][3] + '.png" alt="コンセプト画像">');
      //   currentConcept = questions[idx][3];
      // }
    }

    // 回答チェックボックスのチェック時の処理
    $("input[name=answer]").on("change", function(){
      $("input[name=answer]").prop("checked", false);
      $(this).prop("checked", true);
      $(this).next('label').addClass('kxmegane-label-blink');
      nextQuestion(true);
    })

    // 次へ
    $(".js_kxmegane-btn-next").on("click", function(){
      nextQuestion(false);
    });

    /**
     * index番号を次の番号にして問題表示。
     * 最後の場合は結果表示
     */
    function nextQuestion(animation) {
      if(!selectCheck()){
        // チェックしていない
        return false;
      }

      let questionAnimationSpeed = QUESTION_ANIMATION_SPEED;

      if (animation !== true){
        questionAnimationSpeed = 1;
      }

      // チェックボックスの値を設定
      setCheckboxPoint();
      
      // indexを次へ
      idx++;
      
      // 背景の遷移・画面の遷移
      updateBackgroundByQuestionIndex(idx, "next");

      if(idx == questions.length){

      } else {
        // 連打対応のため位置的にクリック無効
        $("input[name=answer],label").css('pointer-events', 'none');

        setTimeout(function(){
          $("#kxmegane_question-wrap").addClass("js_hide");
        }, questionAnimationSpeed);
        
        // 値をセットし、選択したラベルをcheckedCheck内で点滅させる
        setTimeout(function(){
          // チェックボックスのリセット
          checkedCheck();
          showQuestion();
          $("input[name=answer],label").css('pointer-events', '');

          $(".kxmegane-label-blink").removeClass("kxmegane-label-blink");
          $("#kxmegane_question-wrap").removeClass("js_hide");
        }, questionAnimationSpeed * 2);
      }
    }

    $(".js_kxmegane-btn-prev").on("click", function(){
      prevQuestion();
    });

    /**
     * index番号を前の番号にして問題表示。
     * 最初の場合はガイダンス表示
     */
    function prevQuestion() {
      // 背景の遷移
      updateBackgroundByQuestionIndex(idx, "prev");
      // indexを前へ
      idx--;

      if(!(idx == questions.length - 1)){
        // ボタン表示
        $("#kxmegane_btn_fin_wrap").addClass('hidden').removeClass('js_view');
        $(".js_kxmegane-btn-next").addClass('js_view').removeClass('hidden');
      }

      if(idx < 0){
        // ガイダンスページへ
        $("#kxmegane_page3_qestions").addClass('hidden').removeClass('js_view');
        $("#kxmegane_page2_guidance").addClass('js_view').removeClass('hidden');
        transitionKxmeganeBgByAreaId("bgarea2");
      } else {
        // チェックボックスのリセット
        checkedCheck();
        // 問題表示
        showQuestion();
      }
    }

    /**
     * 戻るを押したときにチェックも戻す
     */
    function checkedCheck(){
      var row = questions[idx];
      var checedVal = row[1];
      if (checedVal > 0){
        $("input[name=answer]").each(function(){
          var val = $(this).val();
          if (checedVal == val){
            $(this).prop("checked", true);
          } else {
            $(this).prop("checked", false);
          }
        });
      } else {
        $("input[name=answer]:checked").prop("checked", false);
      }
    }

    /**
     * セレクトの値をチェックする
     */
    function selectCheck() {
      // エラー文削除
      $("#kxmegane_question-error").html("");
      var is_check = false;
      $("input[name=answer]").each(function(){
        if($(this).prop("checked")){
          is_check = true;
        }
      })
      if(!is_check){
        // エラー文表示
        $("#kxmegane_question-error").html("選択してください。");
      }
      return is_check;
    }

    /**
     * チェックボックスの値を設定
     */
    function setCheckboxPoint() {
      questions[idx][1] = parseInt($("input[name=answer]:checked").val());
      
      // デバッグモードの場合、デバッグエリアを更新
      if (debugMode) {
        updateDebugArea();
      }
    }

    /**
     * デバッグエリアを更新
     */
    function updateDebugArea() {
      if (!debugMode) return;
      
      let debugHtml = '';
      
      // 質問の回答を表示
      for (let i = 0; i < questions.length; i++) {
        const answer = questions[i][1];
        if (answer > 0) {
          debugHtml += `Q${i + 1}, ${answer}<br>`;
        }
      }
      
      // お気に入りの質問を表示
      if (favoriteQuestions.length > 0) {
        debugHtml += '...<br>';
        favoriteQuestions.forEach(function(questionId) {
          debugHtml += `fav[] ${questionId}<br>`;
        });
      }
      
      // デバッグエリアを表示・更新
      $('.debug-area').removeClass('hidden').html(debugHtml);
    }

    /**
     * 大切な質問選択画面を表示
     */
    function showFavoriteQuestion() {
      $('#favorite-question-container').empty();

      answers = $.map(questions, function(question, index) {
        return question[1];
      });

      // querstionDataはオブジェクトなので、キーでソートして配列として処理
      const questionKeys = Object.keys(querstionData).sort((a, b) => parseInt(a) - parseInt(b));
      let questionArray = questionKeys.map(key => querstionData[key]);
      let randQuestionData = [...questionArray].sort(() => Math.random() - 0.5);

      // ランダム版を実際のコンテナに適用
      $.each(randQuestionData, function(index, question) {
        // 元のquerstionDataでの質問のインデックスを取得（0ベース）
        let originalIndex = questionArray.findIndex(q => q.TEXT === question.TEXT);
        // 質問IDは1ベースなので、originalIndex + 1 を使用
        let questionId = originalIndex + 1;
        
        // デバッグモードの場合、質問IDをログ出力
        if (debugMode) {
          console.log(`Question ${index}: originalIndex=${originalIndex}, questionId=${questionId}, text="${question.TEXT.substring(0, 30)}..."`);
        }
        
        $('#favorite-question-container').append(`<input type="checkbox" class="hidden" id="question${index}" data-question-number=${questionId}><label class="kxmegane-fav-label my-3 block relative p-2 pl-12 border border-transparent shadow-sm rounded cursor-pointer fack hover:bg-gray-100 bg-white" for="question${index}">${question.TEXT}</label>`);
        let targetIndex = answers[originalIndex];
        let answerNames = {
          '1': 'その通り！',
          '2': 'まあそうかな',
          '3': 'そうとはいえない',
          '4': '全く違う！',
        };
        // hiddenで非表示に
        for (answerIndex = 1; answerIndex <= 4; answerIndex++) {
          let checkedString = (targetIndex == answerIndex ? 'checked' : '');
          let indexAndAnswerIndex = questionId + '_' + answerIndex
          let html = '<input type="radio" id="answer' + indexAndAnswerIndex + '" class="hidden" name="answer' + questionId +
              '" value="' + answerIndex + '" ' + checkedString +
              ' /><label class="hidden" for="answer' + indexAndAnswerIndex + '">' + answerNames[answerIndex] + '</label>'
          $('#favorite-question-container').append(html);
        }
      });
    }

    //自分にとって大切な質問の選択数上限設定
    $(document).on("change", function(){
      var element = 'input[data-question-number]'
      if ($(element + ':checked').length >= 5) {
        $(element + ':not(:checked)').prop("disabled", true);
      } else if ($(element + ':checked').length < 5) {
        $(element).prop("disabled", false);
      }
    });

    // 遷移時にzoomアウトする関数
    function zoomOutAndChangeBg() {
      $('.butterfly-animation').remove();
      const windowHeight = $(window).height();
      const windowWidth = $(window).width();
      const bgSize = Math.max(windowHeight, windowWidth) * 1.1;
      $('.kxmegane-background-inner')
        .css({
          'background-size': `${bgSize}px ${bgSize}px`,
          'background-position': 'center center'
        });
      $('.kxmegane-content')
        .css({
        'opacity': 0,
      });
      
      // ズームアウト時にも揺らすエフェクトを開始
      startWobbleEffect();
    }

    // 少しだけ引いて中央に行く関数
    function zoomOutAndCenterBg() {
      $('.butterfly-animation').remove();
      const windowHeight = $(window).height();
      const windowWidth = $(window).width();
      const bgSize = Math.max(windowHeight, windowWidth) * CENTER_ZOOM_SCALE;
      $('.kxmegane-background-inner')
        .css({
          'background-size': `${bgSize}px ${bgSize}px`,
          'background-position': 'center center'
        });
      $('.kxmegane-content')
        .css({
        'opacity': 0,
      });
      
      // ズームアウト時にも揺らすエフェクトを開始
      startWobbleEffect();
    }
  
    // 中心座標をもとに、背景画像の位置とサイズを設定する関数
    function setKxmeganeBg(centerX, centerY, displayHeight, displayWidth) {
      const windowWidth = $(window).width();
      const windowHeight = $(window).height();

      // それぞれの拡大率
      const scaleH = windowHeight / displayHeight;
      const scaleW = windowWidth / displayWidth;
      const scale = Math.max(scaleH, scaleW);

      // 背景画像の表示サイズ
      const bgWidth = BG_IMAGE_WIDTH * scale;
      const bgHeight = BG_IMAGE_HEIGHT * scale;

      // 背景の中心座標をウィンドウ中央に合わせる
      const bgImageX = centerX * scale - windowWidth / 2;
      const bgImageY = centerY * scale - windowHeight / 2;

      // パーセント指定
      const bgImageXPer = (bgImageX / (bgWidth - windowWidth)) * 100;
      const bgImageYPer = (bgImageY / (bgHeight - windowHeight)) * 100;

      $('.kxmegane-background-inner').css({
        'background-size': `${bgWidth}px ${bgHeight}px`,
        'background-position': `${bgImageXPer}% ${bgImageYPer}%`
      });
    }

    // 画面遷移時に背景をアニメーションさせる関数
    function transitionKxmeganeBg(centerX, centerY, displayHeight, displayWidth) {
      // 画面遷移開始時にjs_answer-inputをdisabledに
      $('.js_answer-input').prop('disabled', true);

      // まずズームアウト
      zoomOutAndCenterBg();
          
      // ズームアウト後に対象の位置にズームイン
      setTimeout(function() {
        setKxmeganeBg(centerX, centerY, displayHeight, displayWidth);
        
        // 揺らすエフェクトを開始
        startWobbleEffect();
      }, BG_ANIMATION_SPEED);

      // フェードイン
      setTimeout(function() {
        $('.kxmegane-content')
        .css({
          'opacity': 1,
        });

      }, BG_ANIMATION_SPEED * 2);

      // 画面遷移完了後にjs_answer-inputのdisabledを除去
      setTimeout(function() {
        $('.js_answer-input').prop('disabled', false);
      }, BG_ANIMATION_SPEED * 2);

      // リサイズ用に現在の値を更新
      currentCenterX = centerX;
      currentCenterY = centerY;
      currentDisplayHeight = displayHeight;
      currentDisplayWidth = displayWidth;
    }

    // 画面遷移時に背景をアニメーションさせる関数を配列のareaIdで指定
    function transitionKxmeganeBgByAreaId(areaId) {
      const bg = BG_BACKGROUND_POSITION_LIST.find(item => item.areaId === areaId);
      const butterflyConfig = BUTTERFLY_LANDING_POSITIONS.find(item => item.areaId === areaId);
      transitionKxmeganeBg(bg.centerX, bg.centerY, bg.displayHeight, bg.displayWidth);
      
      // 質問エリアに遷移する場合は蝶のアニメーションを実行
      if (areaId.startsWith('bgarea') && butterflyConfig && butterflyConfig.enabled) {
        setTimeout(() => {
          animateButterflies(butterflyConfig);
        }, BG_ANIMATION_SPEED * 1); // 背景アニメーション完了後に蝶を表示
      }
    }

    // 蝶のアニメーション（単数または複数）
    function animateButterflies(butterflyConfig) {
      if (butterflyConfig.multipleButterflies) {
        // 3匹の蝶をアニメーション（スマートフォンとPCで異なる調整）
        const isMobile = isMobileDevice();
        const butterflyPositions = isMobile ? [
          { offsetX: 5, offsetY: 1, delay: 0, startX: 10, startY: 10, endScale: 0.25 },
          { offsetX: -10, offsetY: 0, delay: 500, startX: 50, startY: 50, endScale: 0.20 },
          { offsetX: -3, offsetY: -1, delay: 1000, startX: 90, startY: 90, endScale: 0.15 }
        ] : [
          { offsetX: 5, offsetY: 1, delay: 0, startX: 10, startY: 10, endScale: 0.30 },
          { offsetX: -10, offsetY: 0, delay: 500, startX: 50, startY: 50, endScale: 0.25 },
          { offsetX: -5, offsetY: -1, delay: 1000, startX: 90, startY: 90, endScale: 0.20 }
        ];

        butterflyPositions.forEach((pos, index) => {
          setTimeout(() => {
            createButterfly(butterflyConfig.percentX + pos.offsetX, butterflyConfig.percentY + pos.offsetY, pos.startX, pos.startY, pos.endScale);
          }, pos.delay);
        });
      } else {
        // 1匹の蝶をアニメーション
        const endScale = isMobileDevice() ? 0.25 : 0.30;
        createButterfly(butterflyConfig.percentX, butterflyConfig.percentY, 50, 50, endScale);
      }
    }

    // 1匹の蝶を作成してアニメーション
    function createButterfly(landingX, landingY, startX = 50, startY = 50, endScale = 0.30) {
      const butterfly = $('<div class="butterfly-animation" style="position: fixed; z-index: 1000; pointer-events: none;">' +
        '<img src="/kxmegane/img/butterfly.svg" style="width: 120px; height: 120px;">' +
        '</div>');
      
      $('body').append(butterfly);

      // アニメーション実行
      butterfly.css({
        left: startX + '%',
        top: startY + '%',
        transform: 'scale(5)',
        opacity: 0
      });

      // 蝶が降りてきて着地するアニメーション
      butterfly.animate({
        left: landingX + '%',
        top: landingY + '%',
        opacity: 1
      }, {
        duration: 2000,
        easing: 'swing',
        step: function(now, fx) {
          if (fx.prop === 'top') {
            // 位置に応じてスケールも同時に変化
            const progress = fx.pos;
            const startScale = 5;
            const currentScale = startScale + (endScale - startScale) * progress;
            $(this).css('transform', `scale(${currentScale})`);
          }
        }
      });
    }

    // 画面を切り替えつつ、背景を移動する
    function switchContentAndTransitionBg(hideObjSerector, showObjSerector, backgroundSerector = null) {
      // 現在のコンテンツを非表示に
      $(hideObjSerector).addClass('hidden').removeClass('js_view');

      if (backgroundSerector){
        // 背景の遷移がある場合は背景移動した後にコンテンツを表示する
        transitionKxmeganeBgByAreaId(backgroundSerector);
        setTimeout(function() {
          $(showObjSerector).addClass('js_view').removeClass('hidden');
        }, BG_ANIMATION_SPEED );
      } else {
        // 背景の遷移がない場合は即座に次のコンテンツを表示する
        $(showObjSerector).addClass('js_view').removeClass('hidden');
      }
    }

    // 設問ごとでエリアを移動する関数
    function updateBackgroundByQuestionIndex(questionIndex, direction) {  
      let targetArea;

      // 問題番号に応じて遷移先を指定
      if(direction === "next"){
        if (questionIndex === 0) {
          targetArea = "bgarea3";
        } else if (questionIndex === 10) {
          targetArea = "bgarea4";
        } else if (questionIndex === 20) {
          targetArea = "bgarea5";
        } else if (questionIndex === 30) {
          // 休憩画面を表示
          $("#kxmegane_page3_qestions").addClass('hidden').removeClass('js_view');
          setTimeout(function() {
            $("#kxmegane_page4_rest").addClass('js_view').removeClass('hidden');
          }, BG_ANIMATION_SPEED );
          targetArea = "bgarea6";
        } else if (questionIndex === 40) {
          targetArea = "bgarea8";
        } else if (questionIndex === 50) {
          transitionKxmeganeBgByAreaId("bgarea9");
          $("#kxmegane_page3_qestions").addClass('hidden').removeClass('js_view');
          setTimeout(function() {
            $("#kxmegane_page5_guidance").addClass('js_view').removeClass('hidden');
          }, BG_ANIMATION_SPEED );
        }
      
      } else if (direction === "prev"){
        if (questionIndex === 0) {
          targetArea = "bgarea2";
        } else if (questionIndex === 10) {
          targetArea = "bgarea3";
        } else if (questionIndex === 20) {
          targetArea = "bgarea4";
        } else if (questionIndex === 30) {
          // 休憩画面を表示
          $("#kxmegane_page3_qestions").addClass('hidden').removeClass('js_view');
          setTimeout(function() {
            $("#kxmegane_page4_rest").addClass('js_view').removeClass('hidden');
          }, BG_ANIMATION_SPEED );
          targetArea = "bgarea6";
        } else if (questionIndex === 40) {
          targetArea = "bgarea7";
        }
      }

      // 遷移先が指定されている場合のみ背景を変更
      if (targetArea) {
        transitionKxmeganeBgByAreaId(targetArea);
      }
    }

    // ウィンドウリサイズ時に背景サイズ調整
    $(window).on('resize', debouncedResizeHandler);

    // 初期化時に現在のサイズを記録
    $(document).ready(function() {
      lastWindowHeight = window.innerHeight;
      lastWindowWidth = window.innerWidth;
    });

    window.onbeforeunload = function() {
      return '入力された内容は保存されません。';
    };

    /**
     * フォームのバリデーション設定
     */
    function setupFormValidation() {
      
      // 既存のイベントハンドラーを削除
      $('form.kxmegane_submit').off('submit');
      $('#kxmegane_btn_to_result').off('click');
      
      // フォームのsubmitイベントをキャッチしてバリデーション実行
      $('form.kxmegane_submit').on('submit', function(e) {
        e.preventDefault();
        
        // バリデーション実行
        if (!validateFinalSubmission()) {
          return false;
        }
        
        // まずズームアウト
        zoomOutAndChangeBg();
        
        setTimeout(function() {
          window.onbeforeunload = null;
          // フォームを再送信
          $(this).off('submit').submit();
        }.bind(this), BG_ANIMATION_SPEED);
      });

      // ボタンのクリックイベントも残しておく（フォールバック用）
      $('#kxmegane_btn_to_result').on('click', function(e) {
        e.preventDefault();
        // フォームのsubmitイベントをトリガー
        $('form.kxmegane_submit').trigger('submit');
      });
    }

    /**
     * 最終送信前のバリデーション
     */
    function validateFinalSubmission() {

      let validationErrors = [];
      
      // 1. 全ての質問に回答しているかチェック
      let unansweredQuestions = [];
      
      for (let i = 0; i < questions.length; i++) {
        if (questions[i][1] === 0) {
          unansweredQuestions.push(i + 1);
        }
      }
      
      
      if (unansweredQuestions.length > 0) {
        validationErrors.push(`未回答の質問があります（質問${unansweredQuestions.join('、')}）`);
      }
      
      // 2. お気に入りの質問が選択されているかチェック
      
      if (favoriteQuestions.length === 0) {
        validationErrors.push('「自分にとって大切」な質問を1つ以上選択してください');
      }
      
      // 3. 名前が入力されているかチェック
      const name = $('#input_name').val().trim();
      
      if (name === '') {
        validationErrors.push('名前を入力してください');
      }
      
      // 4. 会社名が入力されているかチェック
      const companyName = $('#input_company_name').val().trim();
      
      if (companyName === '') {
        validationErrors.push('会社名を入力してください');
      }

      // エラーがある場合は表示して送信を停止
      if (validationErrors.length > 0) {
        showValidationErrors(validationErrors);
        return false;
      }
      
      // エラーがない場合はエラーメッセージをクリア
      clearValidationErrors();
      return true;
    }

    /**
     * バリデーションエラーを表示
     */
    function showValidationErrors(errors) {
      // エラーメッセージ用の要素を作成または取得
      let errorContainer = $('#kxmegane-validation-errors');
      if (errorContainer.length === 0) {
        errorContainer = $('<div id="kxmegane-validation-errors" class="validation-error-container"></div>');
        $('#kxmegane_page8_last').prepend(errorContainer);
      }
      
      // エラーメッセージをHTMLで構築
      const errorHtml = `
        <div class="validation-error-message">
          <h3>以下の項目を確認してください：</h3>
          <ul>
            ${errors.map(error => `<li>${error}</li>`).join('')}
          </ul>
        </div>
      `;
      
      errorContainer.html(errorHtml);
      
      // エラーメッセージまでスクロール
      errorContainer[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // 送信ボタンを一時的に無効化
      $('#kxmegane_btn_to_result').prop('disabled', true).addClass('disabled');
      
      // 3秒後にボタンを再有効化
      setTimeout(function() {
        $('#kxmegane_btn_to_result').prop('disabled', false).removeClass('disabled');
      }, 3000);
    }

    /**
     * バリデーションエラーをクリア
     */
    function clearValidationErrors() {
      $('#kxmegane-validation-errors').remove();
    }

    // 揺らすエフェクト用のkeyframesを動的に生成
    function createWobbleKeyframes() {
  
      return [
        { percent: 0, x: 0, y: 0 },
        { percent: 30, x: 40, y: 30 },
        { percent: 70, x: -20, y: -25 },
        { percent: 100, x: 0, y: 0 }
      ];
    }

    // 揺らすエフェクトを開始する関数
    function startWobbleEffect() {
      
      // kxmegane-background要素の存在確認
      const bgElement = $('.kxmegane-background');
      if (bgElement.length === 0) {
        console.error('kxmegane-background element not found');
        return;
      }
      
      // 揺らぎキーフレームを生成
      const keyframes = createWobbleKeyframes();
      
      // アニメーション用のCSSを動的に生成
      const animationName = 'wobble_' + Date.now();
      const keyframeCSS = `
        @keyframes ${animationName} {
          ${keyframes.map(kf => {
            return `${kf.percent}% { transform: translate(${kf.x}px, ${kf.y}px); }`;
          }).join('\n')}
        }
      `;
      
      // スタイルタグを追加
      const styleTag = $('<style>').text(keyframeCSS);
      $('head').append(styleTag);
      
      // kxmegane-backgroundにアニメーションを適用
      bgElement.css({
        'animation': `${animationName} ${BG_ANIMATION_SPEED * 0.9}ms ease-in-out forwards`
      });
      
      // アニメーション完了後にスタイルタグを削除
      setTimeout(() => {
        styleTag.remove();
        // アニメーション完了後はアニメーションのみをクリア（transformは変更しない）
        bgElement.css({
          'animation': 'none'
        });
      }, BG_ANIMATION_SPEED * 0.9);
    }
  } // $("#kxmegane").is(':visible')
});
